<template>
  <div id="divContainer" v-on:click="exitmenu" class="page-effect">
    <!-- <TopMenu /> -->
    <!--<iframe
      async
      src="https://walls.io/c4jga?nobackground=1&amp;show_header=0"
      data-wallurl="https://walls.io/c4jga?nobackground=1&amp;show_header=0"
      data-title="My social wall"
      data-autoheight="1"
      data-lazyload="1"
      class="full-page-frame"
    ></iframe>-->
    <!--<iframe
      async
      src="https://walls.io/bnicelebrate?nobackground=1&amp;show_header=0"
      data-wallurl="https://walls.io/bnicelebrate?nobackground=1&amp;show_header=0"
      data-title="My social wall"
      data-autoheight="1"
      data-lazyload="1"
      class="full-page-frame"
    ></iframe>-->

    <div v-html="embededIframe"></div>

    <iframe
      allowfullscreen
      id="wallsio-iframe"
      src="https://walls.io/neche2020am?nobackground=1&amp;show_header=0"
      style="border: 0; height: 800px; width: 100%"
      loading="lazy"
      title="NECHE 2020"
    ></iframe>
  </div>
</template>

<script>
// import HelloWorld from "@/components/HelloWorld.vue";
// import Router from "vue-router";
// import firebase from "firebase";
//import TopMenu from "@/components/TopMenu.vue";
import db from "../components/firebaseInit";
import jQuery from "jquery";
let $ = jQuery;
export default {
  components: {
    //TopMenu
  },
  data() {
    return {
      embededIframe: "",
    };
  },
  mounted() {
    $("#btnAddUserView").click();
    $("#topmenu").show();
    if ($("#ulLeftMenu li").length > 0) {
      $("#leftMenuParent").show();
      $("#leftmenu").show();
    } else {
      $("#leftMenuParent").hide();
      $("#leftmenu").hide();
    }
    var obj = JSON.parse(window.localStorage.getItem("my-app"));
    $("#divBannerTop").css("background-color", obj.EventBranding[0].topBar);
    $("#divContainer").css(
      "background-image",
      "url(" + obj.EventBranding[0].eventBGImage + ")"
    );
    self.setFirebaseAppsettings();
  },
  methods: {
    setFirebaseAppsettings: function () {
      var docRefGeneralSettings = db
        .collection("OA_UAT")
        .doc("GeneralSettings");
      docRefGeneralSettings.get().then(function (doc) {
        if (doc.exists) {
          self.embededIframe =
            doc.data().embededIframe != undefined
              ? doc.data().embededIframe
              : true;
        }
        console.log("embededIframe - " + self.embededIframe);
      });
    },
  },
};
</script>


<style scoped>
.full-page-frame {
  height: calc(100vh - 116px) !important;
  width: 100%;
}
</style>
